import React, { useEffect, useState, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Spin, Result } from 'antd';

const AuthCallback = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const location = useLocation();
  const { checkAuthState } = useAuth();

  const handleAuthCallback = useCallback(async () => {
    
    try {
      // Check if there's an authorization code in the URL
      const urlParams = new URLSearchParams(location.search);
      const code = urlParams.get('code');
      const error = urlParams.get('error');

      if (error) {
        setError(error);
        setLoading(false);
        return;
      }

      if (code) {
        // The code will be automatically handled by Amplify
        // We just need to wait for the authentication to complete
        // Give Amplify more time to process the auth code
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        // Check the authentication state
        await checkAuthState();
        
        // Wait a bit more to ensure the auth state is properly set
        await new Promise(resolve => setTimeout(resolve, 500));
        
        // Redirect to the online converter
        history.replace('/online-builder');
      } else {
        // No code found, redirect to login
        history.replace('/login');
      }
    } catch (error) {
      console.error('Auth callback error:', error);
      setError(error.message || 'Authentication failed');
      setLoading(false);
    }
  }, [location.search, checkAuthState, history]);

  useEffect(() => {
    handleAuthCallback();
  }, [handleAuthCallback]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        minHeight: 0,
        flex: 1,
        flexDirection: 'column'
      }}>
        <Spin size="large" />
        <div style={{ marginTop: 16 }}>
          Completing authentication...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        minHeight: 0,
        flex: 1
      }}>
        <Result
          status="error"
          title="Authentication Failed"
          subTitle={error}
          extra={[
            <button
              key="retry"
              onClick={() => window.location.href = '/login'}
              style={{
                background: '#1890ff',
                color: 'white',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              Try Again
            </button>
          ]}
        />
      </div>
    );
  }

  return null;
};

export default AuthCallback; 